import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Form, Field } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { newThreadValidation } from '../../../models/survey/SurveySubmissionValidation';
import FormTextField from '../../form/FormTextField';
import BoardPostGalleryFormItem from './BoardPostGalleryFormItem';
import BoardPostFilesFormItem from './BoardPostFilesFormItem';

const NewThreadForm = ({ t, onSubmit }) => (
  <Form
    onSubmit={onSubmit}
    validate={newThreadValidation}
    mutators={{
      ...arrayMutators
    }}
    render={({ handleSubmit }) => (
      <form onSubmit={handleSubmit} id="newThreadForm">
        <div>
          <Field
            name="title"
            component={FormTextField}
            label={t('surveyDetails.boardTab.newThreadDialog.form.titleLabel')}
            placeholder={t('surveyDetails.boardTab.newThreadDialog.form.titlePlaceholder')}
            fullWidth
            autoFocus
          />
        </div>
        <div>
          <Field
            name="content"
            component={FormTextField}
            label={t('surveyDetails.boardTab.newThreadDialog.form.contentLabel')}
            placeholder={t('surveyDetails.boardTab.newThreadDialog.form.contentPlaceholder')}
            fullWidth
            multiline
            rows={4}
          />
        </div>
        <div>
          <BoardPostGalleryFormItem />
        </div>
        <div>
          <BoardPostFilesFormItem />
        </div>
      </form>
    )}
  />
);

NewThreadForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default translate()(NewThreadForm);



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/board/NewThreadForm.js